import React, { useState } from 'react'
import { NoData } from '../../Assets/Images/icons/noData'
import injectStyles from 'react-jss'
import { styles } from './styles'

const TooltipV2 = ({ content, iconFill, classes }) => {
  const [show, setShow] = useState(false)
  return (
    <div
      className={classes.container}
      onMouseOver={() => setShow(true)}
      onMouseOut={() => setShow(false)}
    >
      <NoData fill={iconFill} />
      {show && (
        <div>
          <div className={classes.modal}>
            <div className={classes.logo}>
              <NoData width="15" height="15" />
            </div>
            <div className={classes.text}>{content}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(TooltipV2)
